var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"productMenu-container"},_vm._l((_vm.navItems),function(item){return _c('div',[_c('p',{class:{ active: _vm.currentPath === item.route },on:{"click":function($event){return _vm.handleClick(item.route)}}},[_vm._v(_vm._s(item.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }